import { Mail } from "lucide-react";
import { SiDiscord, SiInstagram, SiTelegram, SiX } from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa6";
import { Reveal, SplitLines } from "@/components/motion/Reveal";

export const SOCIAL_LINKS = [
  { id: "telegram", label: "Join Telegram", href: "https://t.me/forexbrokersignals", Icon: SiTelegram },
  { id: "x", label: "Follow on X", href: "https://x.com/forexbrokersignals", Icon: SiX },
  { id: "discord", label: "Join Discord", href: "https://discord.gg/forexbrokersignals", Icon: SiDiscord },
  { id: "subscribe", label: "Subscribe", href: "/contact", Icon: Mail },
  { id: "instagram", label: "Follow on Instagram", href: "https://instagram.com/forexbrokersignals", Icon: SiInstagram },
  { id: "linkedin", label: "Connect on LinkedIn", href: "https://linkedin.com/company/forexbrokersignals", Icon: FaLinkedinIn },
];

export const PreFooterCTA = () => (
  <section className="relative overflow-hidden" data-testid="prefooter-cta">
    <div className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,var(--canvas)_0%,#eaf1ff_100%)]" aria-hidden />
    <div className="absolute inset-0 -z-10 cta-glow" aria-hidden />

    <div className="container-x relative flex flex-col items-center pt-14 pb-20 text-center lg:pt-16 lg:pb-24">
      <Reveal>
        <p className="eyebrow text-[var(--cobalt)]">Community · Research · Updates</p>
      </Reveal>
      <SplitLines as="h2" inView lines={["Better Broker Decisions", <span key="l2" className="text-[var(--ink-3)]">Start <span className="text-[var(--cobalt)]">Here</span></span>]} className="t-h2 mt-5 lg:text-[56px]" />
      <Reveal delay={0.3} className="mt-8 flex flex-wrap items-center justify-center gap-2" data-testid="prefooter-social-row">
        {SOCIAL_LINKS.map(({ id, label, href, Icon }) => (
          <a key={id} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noreferrer" : undefined}
            className="pill-cta" data-testid={`prefooter-link-${id}`}>
            <Icon size={13} aria-hidden /> {label}
          </a>
        ))}
      </Reveal>
    </div>

    <svg className="absolute bottom-0 left-0 h-[36px] w-full lg:h-[52px]" viewBox="0 0 1440 52" preserveAspectRatio="none" aria-hidden>
      <path d="M0 52 L0 44 Q 720 -18 1440 44 L1440 52 Z" fill="#ffffff" />
    </svg>
  </section>
);
